<template>
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item @click="$router.push({ path: '/knowledge/index'})" style="cursor: pointer;">首页</a-breadcrumb-item>
      <a-breadcrumb-item>知识产权交易</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="serch_border">
    <div class="serchform">
      版权行业类型：
      <a-tag :class="{'tag-active':copyrightTypes==''}" @click="postSerchData({copyrightType:''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==copyrightTypes}" @click="postSerchData({copyrightType:item.dictValue})" v-for="(item,key) in options" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <a-radio-group v-model:value="large">
    <a-radio-button :class="{radioClass:active=='版权交易'}" @click="getSerchData('3')" value="large">版权交易</a-radio-button>
    <a-radio-button :class="{radioClass:active=='专利交易'}" @click="getSerchData('1')" value="default">专利交易</a-radio-button>
    <!-- <a-radio-button :class="{radioClass:active=='商标交易'}" @click="active='商标交易'" value="small">商标交易</a-radio-button> -->
  </a-radio-group>
  <div class="cont_body">
    <div class="body_img">
      <img v-if="active=='版权交易'" src="../../../img/bqjy.jpg" />
      <img v-if="active=='专利交易'" src="../../../img/zljy.jpg" />
      <img v-if="active=='商标交易'" src="../../../img/bqjy.jpg" />

    </div>
    <div class="body_cont">
      <div v-if="active=='版权交易'">
        
        <div v-for="(item,key) in optionsData" :key="key" @click="goMore('/knowledge/investor/page','知识产权交易',item.id)" class="list_cont list_cont_bq">
          <div>
            <div class="list_img_bq">
              <img v-if="item.knowledgeCopyright.icon" :src="getImg(item.knowledgeCopyright.icon)" alt="">
              <img v-else src="@/assets/img/defaultPhoto.png" alt="">
            </div>
            <h4>{{ item.propertyNames }}</h4>
          </div>
          <div class="list_cont_body_bq">
            
            <P>分类：
              <dict-render :dict-obj="dictObjs['projectType']"
              :text="item.knowledgeCopyright.copyrightType"></dict-render>
            </P>
            <p>
              适用范围：<dict-render :dict-obj="dictObjs['copyright_scope']"
              :text="item.knowledgeCopyright.copyrightRange"></dict-render>
            </p>
            <h3 v-if="item.priceType=='0'">
              {{item.price}}<span>元</span>
            </h3>
            <h3 v-else>
              面议
            </h3>

            <a-button>咨询购买</a-button>
          </div>
        </div>
      </div>
      <div v-if="active=='专利交易'">
        <div v-for="(item,key) in optionsData" :key="key" @click="goMore('/knowledge/investor/page','知识产权交易',item.id)" class="list_cont list_cont_zl">
          <div>
            <div class="list_img_zl">
              <img v-if="item.knowledgePatent.icon" :src="getImg(item.knowledgePatent.icon)" alt="">
              <img v-else src="@/assets/img/defaultPhoto.png" alt="">
            </div>
          </div>
          <div class="list_cont_body_zl">
            
            <h4>{{ item.propertyNames }}</h4>
            <P style="
            text-align: left;
            word-break: break-all;
            overflow:hidden; 
            text-overflow:ellipsis; 
            display:-webkit-box;
            -webkit-box-orient:vertical;  
            -webkit-line-clamp:1;">类型：
              <dict-render :dict-obj="dictObjs['projectType']"
              :text="item.knowledgePatent.patentCategory"></dict-render>
            </P>
            <p>
              交易方式：
              <dict-render :dict-obj="dictObjs['tradeMode']"
              :text="item.tradeMode"></dict-render>
            </p>
            <p>
              有效期：{{ momentFormat(item.knowledgePatent.validityEnd,'YYYY-MM-DD') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</template>
<script>
import { dictMixin } from "@/mixins";
import {knowledgePropertyTransactionWeb} from "@/api/knowledge";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 查询条件
      active:'',
      copyrightTypes: '',// 投资领域
      financeDict,
      options:null,
      dictNames: 'position,invest_limits,projectType,copyright_scope,tradeMode',
      optionsData:null,
      propertyTypes:'3'
    }
  },
  mounted() {
    this.getDict();
    
    if(this.$route.query.zlData){
            this.active = this.$route.query.zlData
            this.getSerchData('1')
          }else{
            this.active = '版权交易'
            this.getSerchData('3')
          }
  },
	methods: {
    postSerchData(val){
      if(val.copyrightType||val.copyrightType==''){
        this.copyrightTypes = val.copyrightType
      }
        this.getSerchData(this.propertyTypes)
      
    },
    getSerchData(num){
      this.propertyTypes = num
      this.getAction({
            url: knowledgePropertyTransactionWeb.pageList,
            params: {
              pageNum: 1,
              pageSize: 10,
              propertyType:this.propertyTypes,//1专利2商标3版权
              copyrightType: this.copyrightTypes,
              // quota: this.invest_limits
            },  
        }).then(res => {
            if('3'==num){
              this.active='版权交易'
            }else if('1'==num){
              this.active='专利交易'
            }
          this.optionsData = res.records
        })
    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "projectType"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/knowledge/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.radioClass{
    background: #1890ff;
    color:#fff;
    margin-top: 20px;
}

.list_cont_zl{
  width: 238px;
  display: block!important;
  margin-bottom: 16px;
  margin-right: 16px;
  &:nth-child(4n){
    margin-right: 0;
  }
  h4{
    text-align: center;
    line-height: 50px;
  }
  .list_img_zl{
    width: 100%;
    height: 150px;
    overflow: hidden;
    flex: 1;
    display: flex;
    justify-content: center;
    img{
      height: 100%;
    }
  }
  .list_cont_body_zl{
    flex: 5;
    padding:0 16px 20px;
  }
}

.list_cont_bq{
  width: 238px;
  display: block!important;
  margin-bottom: 16px;
  margin-right: 16px;
  &:nth-child(4n){
    margin-right:0
  }
  h4{
    line-height: 100px;
  }
  .list_img_bq{
    width: 80px;
    float: left;
    height: 80px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:16px;
    flex: 1;
    display: flex;
    align-items: center;
    img{
      width:100%
    }
  }
  .list_cont_body_bq{
    flex: 5;
    clear: both;
    padding: 0 16px;
    padding-bottom: 16px;
    p{
      height: 20px;
      word-break: break-all;
      overflow:hidden; 
      text-overflow:ellipsis; 
      display:-webkit-box;
      -webkit-box-orient:vertical;  
      -webkit-line-clamp:1;

    }
    h3{
      line-height: 60px;
      color:#ff9b18
    }
  }
}
</style>